import React, { useState } from 'react';
import { uploadFile } from '../../services/uploadService';
import { getImageUrl } from '../../utils/imageUrl';

const FileUpload = ({
    label = 'Upload Image',
    value = '',
    onChange, // Callback with uploaded URL string
    accept = 'image/*',
    disabled = false,
    required = false,
    error = '',
    style = {},
}) => {
    const [uploading, setUploading] = useState(false);
    const [uploadError, setUploadError] = useState('');

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        const formData = new FormData();
        formData.append('image', file);

        setUploading(true);
        setUploadError('');

        try {
            const data = await uploadFile(formData);
            const formattedPath = typeof data === 'string'
                ? (data.startsWith('/') ? data : `/${data}`)
                : (data?.path?.startsWith('/') ? data.path : `/${data?.path || ''}`);
            
            if (onChange) {
                onChange(formattedPath);
            }
        } catch (err) {
            console.error('File upload error:', err);
            setUploadError(err.response?.data?.message || 'File upload failed');
        } finally {
            setUploading(false);
        }
    };

    return (
        <div style={{ marginBottom: '16px', width: '100%', ...style }}>
            {label && (
                <label
                    style={{
                        display: 'block',
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#d1d5db',
                        marginBottom: '6px',
                    }}
                >
                    {label} {required && <span style={{ color: '#ef4444' }}>*</span>}
                </label>
            )}

            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '16px',
                    backgroundColor: '#111827',
                    padding: '12px',
                    borderRadius: '8px',
                    border: (error || uploadError) ? '1px solid #ef4444' : '1px solid #374151',
                }}
            >
                {/* Image Preview */}
                {value ? (
                    <div style={{ width: '48px', height: '48px', borderRadius: '6px', overflow: 'hidden', backgroundColor: '#1f2937', flexShrink: 0 }}>
                        <img
                            src={getImageUrl(value)}
                            alt="Preview"
                            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                        />
                    </div>
                ) : (
                    <div style={{ width: '48px', height: '48px', borderRadius: '6px', backgroundColor: '#1f2937', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6b7280', flexShrink: 0 }}>
                        📷
                    </div>
                )}

                {/* File Input Controls */}
                <div style={{ flexGrow: 1 }}>
                    <input
                        type="file"
                        accept={accept}
                        onChange={handleFileChange}
                        disabled={disabled || uploading}
                        style={{
                            color: '#9ca3af',
                            fontSize: '13px',
                            cursor: uploading ? 'wait' : 'pointer',
                        }}
                    />
                    {uploading && (
                        <span style={{ fontSize: '12px', color: '#6366f1', marginLeft: '8px' }}>
                            Uploading...
                        </span>
                    )}
                </div>
            </div>

            {(error || uploadError) && (
                <p style={{ color: '#ef4444', fontSize: '12px', marginTop: '4px', margin: '4px 0 0 0' }}>
                    {error || uploadError}
                </p>
            )}
        </div>
    );
};

export default FileUpload;
